import React, {PureComponent} from "react"
import {Query} from "@irati/utils/services/apollo"
import {QueryProps} from "@irati/utils/apollo"


import {gql} from "@irati/utils/gql"
import {CompanyValue} from "../../types"

const query = gql`
  query CompanyValues($limit: Int, $tenantId: String!) {
    companyValues(limit: $limit, tenantId: $tenantId) {
      results {
        icon {
          href
          alt
        }
        uuid
        tag
      }
    }
  }
`

interface CompanyValuesQueryVariables {
  limit: number
  tenantId: string
}

interface CompanyValuesQueryData {
  companyValues: {
    results: CompanyValue[]
  }
}

const variables = {
  limit: 100
}

interface Props extends QueryProps<CompanyValuesQueryData, CompanyValuesQueryVariables> {
  variables: CompanyValuesQueryVariables
}

export default class CompanyValuesQueryComponent extends PureComponent<Props> {
  static defaultProps = {
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
    query,
    useError: false,
    useLoader: false,
    variables
  }

  render() {
    alert()
    return <Query {...this.props} />
  }
}
